import { ReactNode } from "react";

export type Props = {
  /** Badge content */
  children: ReactNode;
  /** Additional CSS classes */
  className?: string;
  /** Test ID for testing */
  "data-testid"?: string;
};

/**
 * Base badge component with no styling.
 * Use this as the foundation for styled badge components.
 *
 * @example
 * // In shared/ui/Badge.tsx
 * import { BadgeBase, type Props as BadgeBaseProps } from "@core/ui";
 *
 * export function Badge({ className, ...props }: BadgeBaseProps) {
 *   return (
 *     <BadgeBase
 *       className={twMerge(
 *         "inline-flex items-center px-2 py-1 rounded-full text-sm",
 *         className
 *       )}
 *       {...props}
 *     />
 *   );
 * }
 */
export function BadgeBase({
  children,
  className,
  "data-testid": testId = "badge",
}: Props) {
  return (
    <span className={className} data-testid={testId}>
      {children}
    </span>
  );
}

BadgeBase.displayName = "BadgeBase";


